// extracted by css-extract-rspack-plugin
export default {"root":"root-qm_8Wp","comparison":"comparison-xiuDT8"};